<template>
  <div>
    <div class="sidebar-topic-list">
      <div class="container">
        <div class="row">
          <!-- CONTENT -->
          <template v-if="fetching" name="fade" mode="out-in">
            <div class="col-12 content">
              <div
                class="loader d-flex justify-content-center align-items-center my-5 border_grey_dark"
              >
                <div
                  class="icon-dotted-roller font-27 mr-2 animate row color_white"
                ></div>
                <div class="font-16 color_white">Loading ...</div>
              </div>
            </div>
          </template>

          <div v-else class="col-12 content">
            <div v-if="session_data.length > 0">
              <div
                class="title-info font-weight-bold border_grey_dark text-uppercase"
              >
                Browse questions by topic
              </div>

              <!-- TERM SECTION COMPONENT -->
              <TermSection
                @selectTopic="selectedTopic"
                :term_data="session_data[0]"
                :grand_index="0"
                :current_term="getAuthUser.term === 'First' ? true : false"
                :current_week="Number(getAuthUser.week) - 1"
              ></TermSection>

              <TermSection
                @selectTopic="selectedTopic"
                :term_data="session_data[1]"
                :grand_index="1"
                :current_term="getAuthUser.term === 'Second' ? true : false"
                :current_week="Number(getAuthUser.week) - 1"
              ></TermSection>

              <TermSection
                @selectTopic="selectedTopic"
                :term_data="session_data[2]"
                :grand_index="2"
                :current_term="getAuthUser.term === 'Third' ? true : false"
                :current_week="Number(getAuthUser.week) - 1"
              ></TermSection>
              <!-- TERM SECTION COMPONENT -->

              <!-- SHOW MORE TERMS -->
              <div
                v-if="false"
                class="show-more color_white font-weight-bold pointer"
                @click="toggleMoreTerms"
              >
                Show
                <span v-if="show_all_terms">less</span>
                <span v-else>more</span>
                Terms
              </div>
            </div>

            <div class="mt-5" v-else>
              <div
                class="d-flex flex-column justify-content-center align-items-center"
              >
                <img
                  v-lazy="localImg('HugoListEmpty.png')"
                  alt="EmptyTopicList"
                />
                <div class="text-center font-16 brand_white mt-2">
                  No topic found at the moment
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TermSection from "@/components/classComps/assessment/TermSection";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SidebarTopicList",

  components: {
    TermSection,
  },

  computed: {
    ...mapGetters(["getCurrentClass", "getAuthUser"]),
  },

  data() {
    return {
      show_all_terms: false,
      session_data: [],
      questions: [],
      fetching: true,
      account_type: "",
    };
  },

  mounted() {
    this.account_type = this.$route.path.split("/")[1];
    this.fetchTopics();
  },

  methods: {
    ...mapActions(["getTopicsByTerm"]),

    toggleMoreTerms() {
      this.show_all_terms = !this.show_all_terms;
    },

    fetchTopics() {
      // Check Localhost
      if (!localStorage.homework || localStorage.homework == undefined) {
        // redirect to Assesment
        this.$router.replace({
          name:
            this.account_type === "teacher"
              ? "TeacherHomework"
              : "SchoolHomework",
        });
        return;
      }

      let homework = JSON.parse(localStorage.homework);

      this.getTopicsByTerm({
        global_class_id: homework.global_class_id,
        subject_id: homework.subject_id,
      })
        .then((res) => {
          // console.log("Topic By Term", res);
          this.fetching = false;
          if (res.code === 200) {
            this.session_data = res.data.map((item, index) => {
              let topics = item.topics.map((topic, key) => {
                if (topic.status)
                  return {
                    id: key + 1,
                    topic_id: topic.id,
                    title: topic.topic,
                    active: index === 0 && key === 0 ? true : false,
                    class_id: topic.class_id,
                    description: topic.description,
                    subject_id: topic.subject_id,
                    week_number: topic.week_number,
                  };
              });
              return {
                term: `${item.term} Term`,
                topics,
              };
            });

            this.autoSelectTermWeek();
          } else {
            this.$emit("topicSelection", false);
            this.session_data = [];
            // console.log(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // AUTO SELECT TERM AND WEEK
    autoSelectTermWeek() {
      // FIRST TERM SELECTION
      if (this.getAuthUser.term === "First") {
        if (
          Number(this.getAuthUser.week) - 1 >=
          this.session_data[0].topics.length
        )
          this.selectedTopic(this.session_data[0].topics[0]);
        else
          this.selectedTopic(
            this.session_data[0].topics[Number(this.getAuthUser.week) - 1]
          );
      }

      // SECOND TERM SELECTION
      else if (this.getAuthUser.term === "Second") {
        console.log(this.session_data[1].topics.length);
        console.log(Number(this.getAuthUser.week) - 1);

        if (
          Number(this.getAuthUser.week) - 1 >=
          this.session_data[1].topics.length
        )
          this.selectedTopic(this.session_data[1].topics[0]);
        else
          this.selectedTopic(
            this.session_data[1].topics[Number(this.getAuthUser.week) - 1]
          );
      }

      // THIRD TERM SELECTION
      else if (this.getAuthUser.term === "Third") {
        if (
          Number(this.getAuthUser.week) - 1 >=
          this.session_data[2].topics.length
        )
          this.selectedTopic(this.session_data[2].topics[0]);
        else
          this.selectedTopic(
            this.session_data[2].topics[Number(this.getAuthUser.week) - 1]
          );
      }
    },

    selectedTopic(topic) {
      let item = {
        topic_id: topic.topic_id,
        subject_id: topic.subject_id,
        week_number: topic.week_number,
        title: topic.title,
      };
      this.$emit("topicSelection", item);
    },
  },
};
</script>

<style lang="scss">
.sidebar-topic-list {
  .content {
    padding: 30px 25px;
    height: 100%;

    .title-info {
      font-size: 15.5px;
      line-height: 22px;
      margin-bottom: 28px;

      @include breakpoint_max(lg) {
        font-size: 14.5px;
      }

      @include breakpoint_max(sm) {
        font-size: 12.5px;
      }

      @include breakpoint_max(xs) {
        font-size: 11.5px;
      }
    }

    .show-more {
      border-left: 3px solid $brand_accent;
      padding-left: 14px;
      font-size: 13px;
      line-height: 160%;
      margin-top: 33px;

      @include breakpoint_max(sm) {
        font-size: 12px;
      }
    }
  }
}
</style>
